// --- Enums ---

export enum BrazeCurrentEventType {
  NotSet = 0,
  NotParsed = 1,
  MoreThanOneEvent = 2,
  UsersMessagesEmailOpen = 10,
  UsersBehaviorsSubscriptionGlobalStateChange = 11,
  UsersMessagesEmailDelivery = 12,
  UsersMessagesEmailSoftBounce = 13,
  UsersMessagesEmailUnsubscribe = 14,
  UsersMessagesEmailBounce = 15,
  UsersMessagesEmailDeferral = 16,
  UsersMessagesEmailClick = 17,
  UsersCampaignsConversion = 18,
  UsersMessagesEmailSend = 19,
  UsersMessagesEmailMarkAsSpam = 20,
  UsersBehaviorsPushnotificationTokenStateChange = 21,
  UsersMessagesPushnotificationSend = 22,
  UsersMessagesPushnotificationBounce = 23,
  UsersBehaviorsUninstall = 24,
  UsersMessagesPushnotificationOpen = 25,
  UsersMessagesContentcardSend = 26,
  UsersMessagesContentcardImpression = 27,
  UsersMessagesContentcardClick = 28,
  UsersMessagesContentcardDismiss = 29,
  UsersBehaviorsSubscriptiongroupStateChange = 30,
  UsersCanvasEntry = 31,
  UsersCanvasExitMatchedAudience = 32,
  UsersCanvasstepProgression = 33,
  UsersMessagesInappmessageClick = 34,
  UsersMessagesInappmessageImpression = 35,
  UsersCampaignsEnrollInControl = 36,
  UsersMessagesEmailAbort = 37,
  UsersCanvasConversion = 38,
  UsersCanvasExperimentstepConversion = 39,
  UsersCanvasExperimentstepSplitEntry = 40,
  UsersCanvasExitPerformedEven = 41,
}

export const BrazeCurrentEventTypeLabels: Record<number, string> = {
  [BrazeCurrentEventType.NotSet]: "Ej satt",
  [BrazeCurrentEventType.NotParsed]: "Ej tolkad",
  [BrazeCurrentEventType.MoreThanOneEvent]: "Flera händelser",
  [BrazeCurrentEventType.UsersMessagesEmailOpen]: "Email öppnad",
  [BrazeCurrentEventType.UsersBehaviorsSubscriptionGlobalStateChange]:
    "Prenumeration ändrad",
  [BrazeCurrentEventType.UsersMessagesEmailDelivery]: "Email levererad",
  [BrazeCurrentEventType.UsersMessagesEmailSoftBounce]: "Email soft bounce",
  [BrazeCurrentEventType.UsersMessagesEmailUnsubscribe]:
    "Email avprenumererad",
  [BrazeCurrentEventType.UsersMessagesEmailBounce]: "Email bounce",
  [BrazeCurrentEventType.UsersMessagesEmailDeferral]: "Email uppskjuten",
  [BrazeCurrentEventType.UsersMessagesEmailClick]: "Email klickad",
  [BrazeCurrentEventType.UsersCampaignsConversion]: "Kampanjkonvertering",
  [BrazeCurrentEventType.UsersMessagesEmailSend]: "Email skickad Braze",
  [BrazeCurrentEventType.UsersMessagesEmailMarkAsSpam]:
    "Email markerad som spam",
  [BrazeCurrentEventType.UsersBehaviorsPushnotificationTokenStateChange]:
    "Push-token ändrad",
  [BrazeCurrentEventType.UsersMessagesPushnotificationSend]: "Push skickad",
  [BrazeCurrentEventType.UsersMessagesPushnotificationBounce]: "Push bounce",
  [BrazeCurrentEventType.UsersBehaviorsUninstall]: "Avinstallerad",
  [BrazeCurrentEventType.UsersMessagesPushnotificationOpen]: "Push öppnad",
  [BrazeCurrentEventType.UsersMessagesContentcardSend]:
    "Content Card skickad",
  [BrazeCurrentEventType.UsersMessagesContentcardImpression]:
    "Content Card visad",
  [BrazeCurrentEventType.UsersMessagesContentcardClick]:
    "Content Card klickad",
  [BrazeCurrentEventType.UsersMessagesContentcardDismiss]:
    "Content Card stängd",
  [BrazeCurrentEventType.UsersBehaviorsSubscriptiongroupStateChange]:
    "Prenumerationsgrupp ändrad",
  [BrazeCurrentEventType.UsersCanvasEntry]: "Canvas entry",
  [BrazeCurrentEventType.UsersCanvasExitMatchedAudience]:
    "Canvas exit (matched audience)",
  [BrazeCurrentEventType.UsersCanvasstepProgression]:
    "Canvas steg progression",
  [BrazeCurrentEventType.UsersMessagesInappmessageClick]:
    "In-app meddelande klickat",
  [BrazeCurrentEventType.UsersMessagesInappmessageImpression]:
    "In-app meddelande visat",
  [BrazeCurrentEventType.UsersCampaignsEnrollInControl]:
    "Kampanj kontrollgrupp",
  [BrazeCurrentEventType.UsersMessagesEmailAbort]: "Email avbruten",
  [BrazeCurrentEventType.UsersCanvasConversion]: "Canvas konvertering",
  [BrazeCurrentEventType.UsersCanvasExperimentstepConversion]:
    "Canvas experiment konvertering",
  [BrazeCurrentEventType.UsersCanvasExperimentstepSplitEntry]:
    "Canvas experiment split entry",
  [BrazeCurrentEventType.UsersCanvasExitPerformedEven]:
    "Canvas exit (performed event)",
};

// --- Shared item & search types ---

export interface CurrentQueueDetailItem {
  CurrentQueueDetailNo: number;
  CurrentQueueNo: number;
  CustomerNo: number;
  CustomerName: string | null;
  ContactPersonNo: number | null;
  ContactPersonName: string | null;
  CurrentQueueDetailType: number;
  CurrentQueueDetailId: string;
  CurrentQueueDetailProperties: string;
  CurrentQueueDetailProcessed: boolean;
  Created: string;
  CurrentQueueDetailStatus: number;
}

export interface CurrentQueueDetailSearchRequest {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortDir?: "asc" | "desc";
  customerNo?: number | null;
  contactPersonNo?: number | null;
  contactPersonNos?: number[];
  types?: number[];
  statuses?: number[];
  processed?: boolean | null;
  fromDate?: string | null;
  toDate?: string | null;
  currentQueueNo?: number | null;
}

export interface CurrentQueueDetailSearchResponse {
  Items: CurrentQueueDetailItem[];
  Page: number;
  PageSize: number;
  HasNextPage: boolean;
  HasPreviousPage: boolean;
}

// --- sales/summary endpoint ---

export interface SalesSummaryQuery {
  salesResponsibleNo: number;
  fromDate?: string;
  toDate?: string;
}

export interface SalesSummaryContactPerson {
  ContactPersonNo: number;
  ContactPersonName: string;
  TotalItems: number;
}

export interface SalesSummaryByType {
  Type: number;
  Count: number;
}

export interface SalesSummaryByStatus {
  Status: number;
  Count: number;
}

export interface SalesSummaryCampaignByType {
  Type: number;
  Count: number;
}

export interface SalesSummaryByCampaign {
  CampaignId: string;
  CampaignName: string;
  Count: number;
  ByType: SalesSummaryCampaignByType[];
}

export interface SalesSummaryCustomer {
  CustomerNo: number;
  CustomerName: string;
  TotalQueueItems: number;
  ByType: SalesSummaryByType[];
  ByStatus: SalesSummaryByStatus[];
  ByCampaign: SalesSummaryByCampaign[];
  ContactPersons: SalesSummaryContactPerson[];
}

export interface SalesSummaryTotals {
  CustomerCount: number;
  ContactPersonCount: number;
  TotalQueueItems: number;
}

export interface SalesSummaryResponse {
  FromDate: string;
  ToDate: string;
  Customers: SalesSummaryCustomer[];
  Totals: SalesSummaryTotals;
}
